import { IConfig } from '@/types/IConfig';

export class ConfigUtil {
  static get(): IConfig {
    return config as IConfig;
  }
}
